import Slider from 'components/slider-class.js';
import {Utils} from '@busuu/legacy-core';

const sliders = Utils.getElementsByClass('js-slider');
sliders.forEach((item) => new Slider(item));
